import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-box',
    templateUrl: './confirm-box.component.html',
    styleUrls: ['./confirm-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmBoxDialog implements OnInit {

    message: string;
    Hash: string = '';
    UserHash: string = '';
    WithCancelButton: boolean;

    constructor(
        public dialogRef: MatDialogRef<ConfirmBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.message = data.message;
        this.WithCancelButton = data.withCancelButton ? true : data.withCancelButton;
        if (data.withHashCheck) {
            let outString = '';
            const inOptions = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            for (let i = 0; i < 5; i++) {
                outString += inOptions.charAt(Math.floor(Math.random() * inOptions.length));
            }
            this.Hash = outString;
            this.message = `${this.message}\n Saisir ${this.Hash} pour confirmer`;
        }
    }

    ngOnInit() {
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    onConfirm() {
        this.dialogRef.close(true);
    }
}
